import styled from "styled-components";

export const Container = styled.div`
    margin-bottom: 2px;
    display: flex;
    background-color: #fff;
    flex-direction: column;

    &:hover {
        outline: 1px solid #aaa;
    }
`

export const PrimaryContent = styled.div`
    padding: 10px;
    display: flex;
    align-items: center;
    align-content: center;
    background-color: #fff;
`

export const SecondaryContent = styled.div`
    padding: 10px;
    display: flex;
    align-items: center;
    align-content: center;
    background-color: #fafafa;
`

export const CustomerName = styled.span`
    margin-right: 10px;
    font-weight: bold;
`

export const DetailsToogleButton = styled.div`
    padding-right: 10px;
    width: 16px;
    cursor: pointer;
`

export const Values = styled.div`
    display: flex;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex: 1;
    cursor: pointer;
`

export const Options = styled.div`
    padding-left: 10px;
`

export const SecondaryContentCard = styled.div`
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 100%;
    background-color: #fff;
    overflow: hidden;
`

export const SecondaryContentCardHeader = styled.div`
    font-size: 0.9em;
    font-weight: bold;
    padding: 3px 5px;
`

export const SecondaryContentCardItem = styled.div`
    border-top: 1px solid #ddd;
    font-size: 0.9em;
    padding: 3px 5px;
    color: '#999';
    background-color: #fbfbfb;
`